import React, { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import ModalOverlay from '../../components/ModalOverlay';
import './Admin.css';

const EMPTY = { title: '', content: '', is_published: true };

export default function AdminNotices() {
  const [notices, setNotices] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => api.getAllNotices().then(setNotices).catch(() => {});
  useEffect(() => { load(); }, []);

  const openCreate = () => { setForm(EMPTY); setError(''); setModal('create'); };
  const openEdit = (n) => {
    setForm({ title: n.title, content: n.content, is_published: n.is_published });
    setError('');
    setModal(n.id);
  };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      if (modal === 'create') await api.createNotice(form);
      else await api.updateNotice(modal, form);
      setModal(null);
      load();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    await api.deleteNotice(id);
    load();
  };

  return (
    <div>
      <div className="admin-page-header">
        <div className="admin-page-title">공지사항</div>
        <div className="admin-page-sub">공지사항을 작성하고 관리합니다.</div>
      </div>

      <div className="admin-card">
        <div className="admin-toolbar">
          <span style={{ color: '#64748b', fontSize: '0.875rem' }}>총 {notices.length}건</span>
          <button className="btn btn-primary" onClick={openCreate}>+ 공지 작성</button>
        </div>
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>제목</th>
                <th>공개</th>
                <th>작성일</th>
                <th>작업</th>
              </tr>
            </thead>
            <tbody>
              {notices.length === 0 && (
                <tr><td colSpan={4} style={{ textAlign: 'center', color: '#64748b' }}>공지가 없습니다.</td></tr>
              )}
              {notices.map((n) => (
                <tr key={n.id}>
                  <td>{n.title}</td>
                  <td>
                    <span className={`badge ${n.is_published ? 'badge-published' : 'badge-draft'}`}>
                      {n.is_published ? '공개' : '비공개'}
                    </span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {new Date(n.created_at).toLocaleDateString('ko-KR')}
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button className="btn btn-secondary btn-sm" onClick={() => openEdit(n)}>수정</button>
                    {' '}
                    <button className="btn btn-danger btn-sm" onClick={() => remove(n.id)}>삭제</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modal !== null && (
        <ModalOverlay onClose={() => setModal(null)}>
          <div className="modal-title">{modal === 'create' ? '공지 작성' : '공지 수정'}</div>
            <form onSubmit={save}>
              <div className="form-group">
                <label className="form-label">제목</label>
                <input className="form-input" type="text" value={form.title}
                  onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} required />
              </div>
              <div className="form-group">
                <label className="form-label">내용</label>
                <textarea className="form-textarea" value={form.content}
                  onChange={(e) => setForm((f) => ({ ...f, content: e.target.value }))} required
                  style={{ minHeight: 160 }} />
              </div>
              <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input type="checkbox" id="is_published" checked={form.is_published}
                  onChange={(e) => setForm((f) => ({ ...f, is_published: e.target.checked }))} />
                <label htmlFor="is_published" style={{ fontSize: '0.875rem', color: '#374151' }}>공개</label>
              </div>
              {error && <div className="form-error">{error}</div>}
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModal(null)}>취소</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? '저장 중...' : '저장'}
                </button>
              </div>
            </form>
        </ModalOverlay>
      )}
    </div>
  );
}
